import React, { useState } from "react";
import { connect } from "react-redux";
import { addRecipe } from "../Actions/recipeActions";
import AlertTitle from "@mui/material/AlertTitle";
import {
	Button,
	Snackbar,
	TextField,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
} from "@material-ui/core";
import Typography from "@mui/material/Typography";
import cx from 'clsx';
import { makeStyles } from "@material-ui/core/styles";
import { useBouncyShadowStyles } from '@mui-treasury/styles/shadow/bouncy';
import MuiAlert from "@mui/material/Alert";
import { SaveRounded } from "@material-ui/icons";
import { useHistory } from "react-router";

export const RecipeForm = (props) => {
	const [title, setTitle] = useState("");
	const [source, setSource] = useState("");
	const [imageURL, setImageURL] = useState("");
	const [ingrediants, setIngrediants] = useState("");
	const [instructions, setInstructions] = useState("");
	const [category, setCategory] = useState(0);
	const [openSuccess, setopenSuccess] = useState(false);
	const [openFail, setOpenFail] = useState(false);
	//eslint-disable-next-line
	const [loading, setLoading] = useState(false);
	let history = useHistory();

	const Alert = React.forwardRef(function Alert(props, ref) {
		return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
	});

	const handleClose = (e, reason) => {
		if (reason === "clickaway") {
			return;
		}

		setOpenFail(false);
		setopenSuccess(false);
	};

	const onSubmit = (e) => {
		setLoading(true);
		e.preventDefault();
		if (title === "" || source === "") {
			setOpenFail(true);
		} else {
			const newRecipe = {
				recipe_title: title,
				recipe_source: source,
				image: imageURL,
				user_id: props.props,
				ingredients: ingrediants,
				instructions: instructions,
				category_id: category,
			};
			props.addRecipe(newRecipe);
			// .then(() => {
			setopenSuccess(true);
			setLoading(false);
			history.push("/");
			// });
		}
	};

	const styles = {
		display: "flex",
		flexDirection: "column",
		borderRadius: "0.1rem",
		padding: "10px",
		margin: "10px auto",
		width: "auto 0",
		backgroundColor: "#f5f5f5",
		backgroundOpacity: "0.2",
	};

	const useStyles = makeStyles(() => ({
		root: {
			maxWidth: 304,
			margin: 'auto',
			boxShadow: 'none',
			borderRadius: 0,
		},
		content: {
			padding: 24,
		},
		cta: {
			marginTop: 24,
			textTransform: 'initial',
		},
	}));

	const shadowStyles = useBouncyShadowStyles();


	return (
		<div className="recipe-form" style={styles}><br />
			<Typography variant="h5" component="h2" gutterBottom>
				Add a New Recipe or Browse Recipes Below!
			</Typography>
			<form>
				<TextField
					id="recipe-title-input"
					name="recipe-title"
					label="Recipe Title"
					type="text"
					value={title}
					onChange={(e) => setTitle(e.target.value)}
				></TextField>

				<TextField
					id="recipe-source-input"
					name="recipe-source"
					label="Recipe Source"
					type="text"
					value={source}
					onChange={(e) => setSource(e.target.value)}
				></TextField>

				<TextField
					id="recipe-image-input"
					name="recipe-image"
					label="ImageURL"
					type="text"
					value={imageURL}
					onChange={(e) => setImageURL(e.target.value)}
				></TextField>

				<TextField
					id="recipe-ingrediants-input"
					name="recipe-ingrediants"
					label="Ingredients"
					type="text"
					value={ingrediants}
					onChange={(e) => setIngrediants(e.target.value)}
				></TextField>

				<TextField
					id="recipe-instructions-input"
					name="recipe-instructions"
					label="Instructions"
					type="text"
					value={instructions}
					onChange={(e) => setInstructions(e.target.value)}
				></TextField>

				<FormControl sx={{ m: 1, minWidth: 80 }}>
					<InputLabel id="demo-simple-select-autowidth-label">
						Category
					</InputLabel>
					<Select
						labelId="demo-simple-select-autowidth-label"
						id="demo-simple-select-autowidth"
						value={category}
						onChange={(e) => setCategory(e.target.value)}
						autoWidth
						label="Age"
					>
						<MenuItem value="">
							<em>None</em>
						</MenuItem>
						<MenuItem value={0}>Select a Recipe Category</MenuItem>
						<MenuItem value={1}>Breakfast and Brunch Recipes</MenuItem>
						<MenuItem value={2}>Appetizer/Snack Recipes</MenuItem>
						<MenuItem value={3}>Main Dish Recipes</MenuItem>
						<MenuItem value={4}>Salad Recipes</MenuItem>
						<MenuItem value={5}>Dessert Recipes</MenuItem>
						<MenuItem value={6}>Healthy Recipes</MenuItem>
						<MenuItem value={6}>World Cuisine</MenuItem>
					</Select>
				</FormControl><br /><br />

				<Button
					variant="contained"
					color="primary"
					size="large"
					className= {cx(useStyles.root, shadowStyles.root, "button")}
					startIcon={<SaveRounded />}
					onClick={onSubmit}
				>
					Submit
				</Button>
			</form>

			<Snackbar
				open={openSuccess}
				autoHideDuration={6000}
				onClose={handleClose}
			>
				<Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
					Successfully Added!
				</Alert>
			</Snackbar>
			<Snackbar open={openFail} autoHideDuration={6000} onClose={handleClose}>
				<Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
					<AlertTitle>Error</AlertTitle>
					Error — <strong>recipe must contain title and source</strong>
				</Alert>
			</Snackbar>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		user: state.userReducer,
	};
};

export default connect(mapStateToProps, { addRecipe })(RecipeForm);
